import { StylesConfig } from "react-select";

export const customStyles: StylesConfig<any, boolean> = {
  control: (provided) => ({
    ...provided,
    backgroundColor: "#0F60FF",
    border: "none",
    color: "white",
    borderRadius: "6px",
    padding: "4px",
     overflowY: "auto",//scroll
   axHeight: "60px",// scroll
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "6px",
    padding: "8px",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "black",
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: "black",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "white",
  }),
  // scroll code
  valueContainer: (base) => ({
    ...base,
    maxHeight: "50px", // Restrict height
    overflowY: "auto", // Enable scrolling inside the box
  }),
  multiValue: (base) => ({
    ...base,
    backgroundColor: "#e0e0e0", // Optional: better visibility
  }),
};
